export default {
  name: 'share',
  props: {
    shareType: {
      // 分享类型
      type: Array,
      default: function () {
        return ['sina', 'qzon', 'wx'];
      }
    },
    shareTitle: {
      // 分享标题
      type: [String, Number],
      default: ''
    },
    shareUrl: {
      // 分享链接
      type: String,
      default: 'https://cn.vuejs.org/'
    },
    shareImg: {
      // 分享配图      
      type: String,
      default: ''
    },
    shareDirection: {
      // 分享浮窗相对父级的位置，横向：transverse  竖向：vertical
      type: String,
      default: 'transverse'
    },
    shareCodeInterface: {
      // 生成微信二维码接口，默认使用第三方 联图网 的接口
      type: String,
      default: 'http://qr.liantu.com/api.php'
    }
  },
  data: function () {
    return {
      codeImgState: false,
      codeImgUrl: '',
      spanFloat: 'left',
      // 图标浮动
      contentStyle: {},
      contentStyleVertical: {
        'width': '48px',
        'padding': '5px 0'
      },
      contentStyleTransverse: {
        'width': 48 * Number(this.shareType.length) + 'px',
        'padding': '0 5px'
      },
      codeStyle: {},
      codeStyleVertical: {
        'bottom': '0',
        'right': '-80px'
      },
      codeStyleTransverse: {
        'right': '0',
        'bottom': '-80px'
      }
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      let contentStyle = 'contentStyle' + this.shareDirection.substring(0, 1).toUpperCase() + this.shareDirection.substring(1);
      let codeStyle = 'codeStyle' + this.shareDirection.substring(0, 1).toUpperCase() + this.shareDirection.substring(1);
      this.contentStyle = this[contentStyle];
      this.codeStyle = this[codeStyle];

      if (this.shareDirection == 'transverse') {
        this.spanFloat = 'left';
      } else {
        this.spanFloat = 'none';
      }
    });
  },
  methods: {
    toShare(type) {
      this[type]();
    },

    sina: function () {
      window.open('http://v.t.sina.com.cn/share/share.php?title=' + this.shareTitle + '&url=' + encodeURIComponent(this.shareUrl) + '&pic=' + encodeURIComponent(this.shareImg));
    },
    qzon: function () {
      window.open('http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=' + this.shareTitle + '&url=' + encodeURIComponent(this.shareUrl) + '&pics=' + encodeURIComponent(this.shareImg));
    },
    wx: function () {
      this.codeImgUrl = this.shareCodeInterface + '?text=' + encodeURIComponent(this.shareUrl);
      setTimeout(() => {
        this.codeImgState = true;
      }, 300);
    }
  }
};